import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import styles from './styles';

const { publicRuntimeConfig } = getConfig();

const BroadbandPrequalBannerCurve = props => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      component='img'
      sx={styles(theme).PrequalBannerCurve}
      src={
        sm
          ? `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${props.cmsData?.primaryMobileCurveImg?.data?.attributes?.url}`
          : `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${props.cmsData?.primaryDesktopCurveImg?.data?.attributes?.url}`
      }
      alt={props.cmsData?.primaryDesktopCurveImg?.data?.attributes?.alternativeText}
    />
  );
};

export default BroadbandPrequalBannerCurve;
